import { render, staticRenderFns } from "./Consultants2.vue?vue&type=template&id=20223061&scoped=true&"
import script from "./Consultants2.vue?vue&type=script&lang=js&"
export * from "./Consultants2.vue?vue&type=script&lang=js&"
import style0 from "./Consultants2.vue?vue&type=style&index=0&id=20223061&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20223061",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
